/// <reference types="./Logger.d.ts" />
const noop = () => {
    // no-op
};
export const NoOpLogger = {
    error: noop,
    warn: noop,
    info: noop,
    debug: noop,
};
export function createConsoleLogger(console) {
    return {
        error(message, data) {
            if (arguments.length === 1) {
                console.error(`error: ${message}`);
            }
            else {
                console.error(`error: ${message}`, data);
            }
        },
        warn(message, data) {
            if (arguments.length === 1) {
                console.warn(`warn: ${message}`);
            }
            else {
                console.warn(`warn: ${message}`, data);
            }
        },
        info(message, data) {
            if (arguments.length === 1) {
                console.info(`info: ${message}`);
            }
            else {
                console.info(`info: ${message}`, data);
            }
        },
        debug(message, data) {
            if (arguments.length === 1) {
                console.debug(`debug: ${message}`);
            }
            else {
                console.debug(`debug: ${message}`, data);
            }
        },
    };
}
//# sourceMappingURL=Logger.js.map